// @flow
import { getQueryParamValueOrCry } from '@tectonics/commons/query-params';

export type MealVoucherInfo = {
  mealVoucherBrand: string,
};

export function getMealVoucherInfoFromQueryParams(): MealVoucherInfo {
  const mealVoucherBrand = getQueryParamValueOrCry('meal_voucher_brand');

  return {
    mealVoucherBrand,
  };
}
